import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import SaveIcon from '@material-ui/icons/Save';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import AdminGeneralDefinitionsAPI from '../../../API/Admin/AdminGeneralDefinitionsAPI';
import { handleServerError } from '../../../Utils/Helper';
import { ADMIN_GROUP } from '../../../Utils/Constants';


const styles = theme => ({
  paperHeader: {
    padding: 0,
    backgroundColor: '#A5A5A5',
    height: '40px'
  },
  titleHead: {
    padding: '8px 0px 0px 12px',
    color: '#ffffff'
  },
  gridRoot: {
    flexGrow: 1,
    padding: '12px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  paddingAlign: {
    paddingTop: '6px'
  }
});

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={2}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};


class AdminGeneralDefinitionsForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      reservationNumDays: '',
      extensionNumDays: '',
      alertPeriod: '',
      expectedDeliveryDateNumDaysToAdd: '',
      expectedDeliveryDateNumDaysToDeductViaSGE: '',
      openError: false,
      alertMessage: '',
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { }
    };
  }

  componentDidMount() {
    const adminDataAPI = new AdminGeneralDefinitionsAPI();
    adminDataAPI.getAdminTableData().then((response) => {
      this.setState({
        reservationNumDays: response.data.NumDiasReserva,
        extensionNumDays: response.data.NumDiasProlongReserva,
        alertPeriod: response.data.PeriodicidadeAlertas,
        expectedDeliveryDateNumDaysToAdd: response.data.NumDiasSomaDataPrevEngtrega,
        expectedDeliveryDateNumDaysToDeductViaSGE: response.data.NumDiasDeduzDataEntregaSGE
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
      loading: false,
      success: false
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleClickEdit = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende GUARDAR os valores registados?',
      confirmationMessage: 'Os registos serão alterados e guardados na BD, sendo que estes apenas incidirão sobre criações a partir do momento actual.',
      confirmationFunction: this.handleSubmitEdit,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitEdit = () => {
    const adminDataAPI = new AdminGeneralDefinitionsAPI();
    let elementDTO = this.parseStateForSubmit(this.state);
    adminDataAPI.saveEditElement(elementDTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.handleCloseDialog()
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  parseStateForSubmit(estado) {
    let dto = {
      NumDiasReserva: estado.reservationNumDays,
      NumDiasProlongReserva: estado.extensionNumDays,
      PeriodicidadeAlertas: estado.alertPeriod,
      NumDiasSomaDataPrevEngtrega: estado.expectedDeliveryDateNumDaysToAdd,
      NumDiasDeduzDataEntregaSGE: estado.expectedDeliveryDateNumDaysToDeductViaSGE,
    };
    return dto;
  };


  render() {
    const { classes } = this.props;

    return (
      <Paper>

        <Paper className={classes.paperHeader}>
          <Typography align='left' variant='subheading' className={classes.titleHead}>EDITAR ELEMENTOS</Typography>
        </Paper>

        <form>
          <Grid container spacing={8} className={classes.gridRoot}>
            <Grid item xs={12} sm={6}>
              <TextField
                id='newReservationNumDays'
                label='Nº DIAS DE RESERVA'
                fullWidth
                className={classes.paddingAlign}
                value={this.state.reservationNumDays}
                onChange={this.handleChange('reservationNumDays')}
                InputProps={{ readOnly: this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0, inputComponent: InputNumber }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='newExtensionNumDays'
                label='Nº DIAS DE PROLONGAMENTO DE RESERVA'
                fullWidth
                className={classes.paddingAlign}
                value={this.state.extensionNumDays}
                onChange={this.handleChange('extensionNumDays')}
                InputProps={{ readOnly: this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0, inputComponent: InputNumber }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='newAlertPeriod'
                label='PERIODICIDADE DE ALERTAS'
                fullWidth
                className={classes.paddingAlign}
                value={this.state.alertPeriod}
                onChange={this.handleChange('alertPeriod')}
                InputProps={{ readOnly: this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0, inputComponent: InputNumber }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='newExpectedDeliveryDateNumDaysToAdd'
                label='Nº DIAS A ACRESCER À DATA PREVISTA DE ENTREGA'
                fullWidth
                className={classes.paddingAlign}
                value={this.state.expectedDeliveryDateNumDaysToAdd}
                onChange={this.handleChange('expectedDeliveryDateNumDaysToAdd')}
                InputProps={{ readOnly: this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0, inputComponent: InputNumber }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='newExpectedDeliveryDateNumDaysToDeductViaSGE'
                label='Nº DIAS A DEDUZIR À DATA PREVISTA DE ENTREGA PARA ENVIO SGE'
                fullWidth
                className={classes.paddingAlign}
                value={this.state.expectedDeliveryDateNumDaysToDeductViaSGE}
                onChange={this.handleChange('expectedDeliveryDateNumDaysToDeductViaSGE')}
                InputProps={{ readOnly: this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0, inputComponent: InputNumber }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-end'>
                <Grid item>
                  <Tooltip title='Guardar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickEdit}
                      disabled={this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0}>
                      <SaveIcon />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

AdminGeneralDefinitionsForm.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(AdminGeneralDefinitionsForm));


// WEBPACK FOOTER //
// ./src/components/Administration/AdminGeneralDefinitions/AdminGeneralDefinitionsForm.js